"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"


export function MetaAdsCloseConfirmationDialog({
  open,
  connectionSaved,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  connectionSaved: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) {
  const tUi = useTranslations("Integrations.IntegrationsMetaAdsMetaAdsCloseConfirmationDialog")

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle><span key={tUi("closeMetaAdsSetup")}>{tUi("closeMetaAdsSetup")}</span></AlertDialogTitle>
          <AlertDialogDescription>
            <span key={connectionSaved
              ? tUi("yourPageIsSavedButUnfinishedSetupSteps")
              : tUi("yourProgressInThisSetupWindowWillBe")}>{connectionSaved
              ? tUi("yourPageIsSavedButUnfinishedSetupSteps")
              : tUi("yourProgressInThisSetupWindowWillBe")}</span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel><span key={tUi("keepSettingUp")}>{tUi("keepSettingUp")}</span></AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}><span key={tUi("closeSetup")}>{tUi("closeSetup")}</span></AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
